import React, { useState } from 'react'
import useForm from '../../../hooks/useForm';
import apiBusquedas from '../../../services/apis/apiBusquedas';
import ListaAsistentes from './ListaAsistentes';

const SearchAsistente = () => {

    const { values, handleInputChange, reset } = useForm({ valorBusqueda: '' });
    const { valorBusqueda } = values;
    const [ resultados, setResultados ] = useState(null)
    const [ mensajeError, setMensajeError ] = useState( null )

    const handleSearch = async() => {
        console.log('entró')
        const response = await apiBusquedas.buscar('asistentes', valorBusqueda);
        if (response.error ){
            return setMensajeError('Hubo un error intenta de nuevo más tarde')
        }
        console.log(response)
        setMensajeError( null )
        setResultados(response.data.resultados)
        reset();
    }    

    return (
        <div>
            <h5>Buscar asistente</h5>
            <p>Puedes buscar por correo, nombre o Id</p>
            <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                    <div className="col">
                        <input 
                            className='form-control'
                            type="text" name="valorBusqueda" value={ valorBusqueda } onChange={ handleInputChange } />
                    </div>
                    <div className="col-auto">
                        <button onClick={ handleSearch } className="btn btn-primary">
                            Buscar Asistente
                        </button>
                    </div>
                </div>
            </form>
            { mensajeError && <div className='p-2 bg-warning mt-2' ><p> {mensajeError} </p></div> }
            { resultados && <ListaAsistentes asistentes={resultados}/>}
        </div>
    )
}

export default SearchAsistente
